import React from 'react';
import { CalendarOutlined, ArrowRightOutlined } from '@ant-design/icons';
import './MainSection.css';

function MainSection() {
  const scrollToEvents = () => {
    document.querySelector('.events-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    document.querySelector('.contact-form-container')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="main-section">
      <div className="main-bg" />
      <div className="main-overlay" />
      <div className="main-content">
        <div className="main-badge">🎟 Black Canyon Tickets</div>
        <h1>Online Ticketing for <span>Unforgettable</span> Events</h1>
        <p>Any venue, any time. Serving all of the United States with fast, secure, and seamless ticket booking.</p>
        <div className="main-buttons">
          <button className="btn-primary" onClick={scrollToEvents}>
            <CalendarOutlined /> View Events
          </button>
          <button className="btn-secondary" onClick={scrollToContact}>
            Get in Touch <ArrowRightOutlined />
          </button>
        </div>
      </div>
      <div className="main-scroll-hint">
        <span>↓</span>
        SCROLL
      </div>
    </div>
  );
}

export default MainSection;